import { IconCopy } from '@tabler/icons-react';

/** "Give the other pages this page's settings" — the outlined amber button under a page's sliders. */
export default function ApplyToAllButton({ onClick, disabled, className = '', children }) {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`flex w-full items-center justify-center gap-2 rounded-xl border border-amber-500/60 bg-white px-3 py-2.5 text-[13px] font-semibold text-amber-700 transition-colors hover:bg-amber-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-amber-500/40 dark:bg-zinc-900 dark:text-amber-400 dark:hover:bg-amber-500/10 ${className}`}
        >
            <IconCopy size={16} stroke={1.8} />
            {children}
        </button>
    );
}
